module.exports = __webpack_public_path__ + "img/outline2.3c856560.svg";